<template>
  <parent>
    <div class="container">
      <div class="d-block d-sm-flex flex-wrap mb-2">
        <b-button
          variant="bg-white icon-light"
          class="mr-1 mt-1 mt-sm-0"
          @click="$router.push({ name: 'healthchecks' })"
        >
          <GjIcon name="ArrowLeft" />
          Back
        </b-button>
        <b-button
          v-if="$can('update', 'healthchecks', 'snitch')"
          variant="bg-white icon-light"
          class="mr-1 mt-1 mt-sm-0"
          @click="onEditClick(healthcheck.id)"
        >
          Edit
        </b-button>
        <button-loading
          variant="bg-white"
          class="mt-1 mt-sm-0 ml-auto mr-0"
          :spinning="gettingHealthcheck"
          :disabled="gettingHealthcheck"
          @click="onRefresh()"
        >
          <GjIcon
            class="icon-left"
            name="Refresh"
          />
          Refresh
        </button-loading>
      </div>
      <b-card class="text-center">
        <b-tabs
          v-model="tabIndex"
          nav-class="mb-2"
        >
          <b-tab
            title="Details"
            active
            @click="changeActiveTab(0)"
          >
            <div
              v-if="tabIndex === 0"
              :key="layout"
              class="w-100"
            >
              <paper-simple v-if="gettingHealthcheck">
                <loading-page />
              </paper-simple>
              <template v-else>
                <overview />
              </template>
            </div>
          </b-tab>
          <b-tab @click="changeActiveTab(1)">
            <template #title>
              Monitoring
            </template>
            <div
              v-if="tabIndex === 1"
              :key="layout"
              class="w-100"
            >
              <paper-simple v-if="gettingHealthcheck">
                <loading-page />
              </paper-simple>
              <template v-else>
                <monitoring />
              </template>
            </div>
          </b-tab>
          <b-tab @click="changeActiveTab(2)">
            <template #title>
              Results
            </template>
            <div
              v-if="tabIndex === 2"
              :key="layout"
              class="w-100"
            >
              <paper-simple v-if="gettingHealthcheck">
                <loading-page />
              </paper-simple>
              <template v-else>
                <healthcheck-logs />
              </template>
            </div>
          </b-tab>
        </b-tabs>
      </b-card>
    </div>
  </parent>
</template>
<script>
import redirectError from '@/services/redirectError'
import Overview from './views/Details.vue'
import Monitoring from './views/Monitoring.vue'
import HealthcheckLogs from '../healthcheck-logs/HealthcheckLogs.vue'

export default {
  name: 'HealthcheckDetails',
  components: {
    Overview,
    Monitoring,
    HealthcheckLogs,
  },
  data() {
    return {
      id: null,
      activeTab: 0,
      tabIndex: 0,
      hasHealthcheckPermissions: true,
    }
  },
  computed: {
    gettingHealthcheck() {
      return this.$store.state.healthchecks.gettingHealthcheck
    },
    healthcheck() {
      return this.$store.state.healthchecks.healthcheck
    },
    storedDateRange: {
      get() {
        return this.$store.state.healthcheckLogs.dateRange
      },
      set(value) {
        this.$store.commit('healthcheckLogs/SET_DATE_RANGE', value)
      },
    },
    layout() {
      if (this.activeTab === 1) {
        return 'monitoring'
      }
      if (this.activeTab === 2) {
        return 'healthcheck-logs'
      }
      return 'details'
    },
  },
  created() {
    this.id = this.$route.params.healthcheckId
    this.getHealthcheck()
  },
  beforeDestroy() {
    this.clearStore()
  },
  methods: {
    getHealthcheck() {
      this.$store
        .dispatch('healthchecks/getHealthcheck', this.id)
        .catch(error => {
          if (error.response?.status === 403) {
            this.hasHealthcheckPermissions = false
            return
          }
          redirectError(error)
          this.errorToast(error.response?.data?.errors[0] || 'Something went wrong while getting healthcheck.')
        })
    },
    getHealthcheckLogs(pageSize) {
      this.$store
        .dispatch('healthcheckLogs/fetchHealthcheckLogs', {
          healthcheckId: this.id,
          query: {
            pageIndex: 0,
            pageSize,
            state: 2,
          },
        })
        .catch(error => {
          if (error.response?.status === 403) {
            this.hasHealthcheckLogsPermissions = false
            return
          }
          this.errorToast(
            error.response?.data?.errors[0]
              || 'Something went wrong while fetching healthcheck logs!',
          )
        })
    },
    onRefresh() {
      this.getHealthcheck()
      this.clearStore()
    },
    onEditClick(healthcheckId) {
      this.$router.push({
        name: 'healthchecks-edit',
        params: { id: this.id, healthcheckId },
      })
    },
    changeActiveTab(val) {
      this.activeTab = val
    },
    clearStore() {
      this.$store.commit('healthcheckLogs/SET_HEALTHCHECK_LOGS', {
        result: [],
        resultInfo: {},
      })
      this.$store.commit('healthcheckLogs/SET_HEALTHCHECK_STATS', {
        result: [],
        resultInfo: {},
      })
      this.$store.commit('healthcheckLogs/SET_FILTERED_HEALTHCHECK_LOGS', {
        result: [],
        resultInfo: {},
      })
      this.$store.commit('healthcheckLogs/SET_CURRENT_PAGE', 1)
      this.$store.commit('healthcheckLogs/SET_HEALTHCHECK_DATACENTERS', [])
      this.$store.commit('healthcheckLogs/SET_SELECTED_DATACENTER', { id: 0, name: 'All Data Centers', slug: '' })
      this.storedDateRange = {
        ...this.storedDateRange,
        healthcheckId: 0,
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.instance-overview {
  display: flex;
  flex-direction: column;
  height: 100%;
  .details {
    flex: 1;
  }
}
</style>
